export default "__VITE_ASSET__B0rtBr_u__"